import Component from '@glimmer/component';
import type { TargetAudience } from 'common/enums/target-audience.enum';

interface FormationPartsContactPointComponentArgs {
  target: TargetAudience;
}

// eslint-disable-next-line ember/no-empty-glimmer-component-classes
export default class FormationPartsContactPointComponent extends Component<FormationPartsContactPointComponentArgs> {}
